import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { StaticFormGroup } from '@bingads-webui-cc-react/layout';
import { Constants } from '@bingads-webui-clientcenter/entity-utils';
import { TaxCertificateFilePicker, ReverseChargeDocumentFilePicker } from '../../controls';
import { ViewTaxFormPropTypes } from '../../shapes';
import { BaseViewTaxFormList, isConfirmedYes, isConfirmedNo, getPilotStatus } from '../../utils';
import { TaxFormMode, ReverseChargeDocumentAttestationKey, LegalIdentifierNumberPilot } from '../../constants';

const { TaxType } = Constants;

export const GlobalViewTaxForm = ({
  i18n,
  data,
  filledData,
  countryCode,
  taxCertification,
  taxFormMode,
  showLineByLineFormGroup,
  ownerAccountId,
  urlBuilder,
  showTaxCertLink,
  taxSchema,
  taxCertLabel,
  showTaxCert,
  showReverseDocument,
  permissions,
}) => {
  const IsLegalIdentifierNumberPilotOn = getPilotStatus(LegalIdentifierNumberPilot, permissions);
  const filledDataOmitLegalIdentifier = useMemo(() => _.omit(filledData, TaxType.LegalIdentifier), [filledData]);
  const legalIdentifierData = useMemo(() => _.pick(filledData, TaxType.LegalIdentifier), [filledData]);
  return (
    <div className="global-view-tax-form">
      <BaseViewTaxFormList
        i18n={i18n}
        uiObject={IsLegalIdentifierNumberPilotOn ? filledDataOmitLegalIdentifier : filledData}
        countryCode={countryCode}
        taxSchema={taxSchema}
        permissions={permissions}
      />
      {showTaxCert &&
        <TaxCertificateFilePicker
          i18n={i18n}
          mtTaxCertification={taxCertification}
          taxFormMode={taxFormMode}
          showLineByLineFormGroup={showLineByLineFormGroup}
          ownerAccountId={ownerAccountId}
          urlBuilder={urlBuilder}
          showTaxCertLink={showTaxCertLink}
          taxCertLabel={taxCertLabel}
          isGlobalTaxForm
        />
      }
      {showReverseDocument &&
        <ReverseChargeDocumentFilePicker
          i18n={i18n}
          taxFormMode={TaxFormMode.ViewMode}
          mtTaxCertification={taxCertification}
          showLineByLineFormGroup={showLineByLineFormGroup}
          urlBuilder={urlBuilder}
        />}
      {isConfirmedYes(_.result(data, ReverseChargeDocumentAttestationKey)) && (
        <StaticFormGroup showLabel={false} id={`tax-info-${ReverseChargeDocumentAttestationKey}`}>
          {i18n.getString(_TL_("You have attested that the above Reverse Charge Document has been uploaded by an employee of the company that is receiving advertising services from Microsoft Advertising, and that the uploader understands the reverse charge account concept and the company's VAT return filing obligations."))}
        </StaticFormGroup>
      )}
      {isConfirmedNo(_.result(data, ReverseChargeDocumentAttestationKey)) && (
        <StaticFormGroup showLabel={false} id={`tax-info-${ReverseChargeDocumentAttestationKey}`}>
          {i18n.getString(_TL_("You didn’t attest that the above Reverse Charge Document has been uploaded by an employee of the company that is receiving advertising services from Microsoft Advertising, and that the uploader understands the reverse charge account concept and the company's VAT return filing obligations."))}
        </StaticFormGroup>
      )}
      {IsLegalIdentifierNumberPilotOn && !_.isEmpty(legalIdentifierData) && (
        <BaseViewTaxFormList
          i18n={i18n}
          uiObject={legalIdentifierData}
          countryCode={countryCode}
          taxSchema={taxSchema}
        />
      )}
    </div>
  );
};

GlobalViewTaxForm.propTypes = {
  ...ViewTaxFormPropTypes,
  taxCertLabel: PropTypes.string,
  countryCode: PropTypes.string.isRequired,
  showTaxCert: PropTypes.bool,
  showReverseDocument: PropTypes.bool,
};

GlobalViewTaxForm.defaultProps = {
  taxCertLabel: null,
  showTaxCert: true,
  showReverseDocument: false,
};
